import moment from 'moment';
import { LEVEL_VALUES, PACING_STATUS_VALUES } from '../constants/pacing';

export const getPacingStatus = osi => {
  if (!osi) {
    return '';
  }
  if (osi < 0.85) {
    return PACING_STATUS_VALUES.UNDER_PACING;
  }
  if (osi < 0.95) {
    return PACING_STATUS_VALUES.RISK_PACING;
  }
  if (osi < 1.02) {
    return PACING_STATUS_VALUES.ON_TARGET;
  }
  return PACING_STATUS_VALUES.OVER_PACING;
};

export const getPacingTo = (budget, osi) => Number.parseInt(budget * osi);

export const getActiveStatus = active => active > 0;

export const getRemaining = (budget, impressions) => budget - impressions;

export const getDaysRemaining = endDate => moment(endDate).diff(moment(), 'days');

export const getDeliveredToday = (impressions, throughYesterday) => impressions - throughYesterday;

export const getLevelFilter = levelFilter => level => {
  return levelFilter === LEVEL_VALUES.FULL_VIEW || levelFilter === level;
};

export const shouldCutHierarchyToTopLevel = level => level !== LEVEL_VALUES.FULL_VIEW;

export const getUnnamedFlightNamingFunction =
  (lineItemFligths = new Map()) =>
  (parentKey = '', lineItemName = '') => {
    const flights = lineItemFligths?.get(parentKey) || [];
    return `${lineItemName}: Flight #${(flights?.length || 0) + 1}`;
  };

export const wait = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
